import type { SelectProps } from "./Select.types";
import { useSelect } from "./useSelect";
import {
  getWrapperStyles,
  getLabelStyles,
  getSelectTriggerStyles,
  getTriggerTextStyles,
  getDropdownPanelStyles,
  getOptionItemStyles,
} from "./Select.styles";
import { Text } from "../../atoms/Text";
import { Icon } from "../../atoms/Icon";
import { ListItem } from "@/molecules/ListItem";

export const Select = ({
  id,
  label,
  iconLeft,
  value,
  variant = "default",
  onValueChange,
  options,
  placeholder = "Selecione...",
  state = "default",
  disabled = false,
  readonly = false,
  containerClassName,
}: SelectProps) => {
  const { isOpen, closeMenu, wrapperRef, listboxId, getTriggerProps } = useSelect();

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelectItem = (optionValue: string) => {
    onValueChange(optionValue);
    closeMenu();
  };

  return (
    <div
      className={getWrapperStyles(containerClassName)}
      ref={wrapperRef}
    >
      {label && (
        <Text
          as="label"
          variant="label"
          htmlFor={id}
        >
          {label}
        </Text>
      )}

      <button
        id={id}
        type="button"
        role="combobox"
        disabled={disabled || readonly}
        className={getSelectTriggerStyles({
          state,
          variant,
          disabled,
          iconLeft,
          readonly,
        })}
        {...getTriggerProps()}
      >
        {iconLeft && <Icon name={iconLeft} />}

        <span className={getTriggerTextStyles(!!selectedOption)}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>

        <Icon name="caret-down" />
      </button>

      {isOpen && !readonly && (
        <div
          id={listboxId}
          role="listbox"
          className={getDropdownPanelStyles()}
        >
          <ul className="flex flex-col">
            {options.map((option) => (
              <ListItem
                onClick={() => handleSelectItem(option.value)}
                label={option.label}
                id={option.value}
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
